<template>
  <div
    class="edit-select-clip-audio"
    :class="{
      [`edit-select-clip-audio--${createRenderType}`]: true,
    }"
  >
    <div class="edit-select-clip-audio-select-area-box flex">
      <div class="edit-select-clip-audio-select-area-time width-0 flex1">
        {{
          `${mediaUtil.formatTime(
            renderData.duration * renderData.progress > 0
              ? renderData.duration * renderData.progress
              : 0
          )} / ${mediaUtil.formatTime(renderData.duration)}`
        }}
      </div>
      <div class="edit-select-clip-audio-select-close" v-if="!props.hideRemove">
        <IconButton
          size="32px"
          icoSize="20px"
          @onClick="onRemoveClick"
          backgroundColor="rgba(255, 255, 255, 0.1)"
          hoverBackgroundColor="rgba(255, 255, 255, 0.2)"
        >
          <img src="@/assets/img/editor/delete-remove-ico.png" />
        </IconButton>
      </div>
    </div>
    <div class="edit-select-clip-audio-select-area-edit-box">
      <ClippingSelectDuration
        v-if="renderData.ifRenderClippingSelectDuration"
        ref="refClippingSelectDuration"
        :config="props.config"
        :type="props.type"
        :duration="renderData.duration"
        :formatTime="props.type == 'select' ? null : formatTime"
        :waveformData="renderData.waveformData"
        :onlyRenderMode="true"
        :progress="renderData.progress"
        :isPlaying="renderData.isPlaying"
        @syncSelectData="doSyncSelectData"
        @syncProgress="doSyncProgress"
        @selectDataChange="doSelectDataChange"
        @togglePlay="doTogglePlay"
        @changeProgress="doChangeProgress"
        @selectChangeLimit="doSelectChangeLimit"
      />
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";

import { useRouter, useRoute } from "vue-router";

import IconButton from "@/components/basic/button/IconButton.vue";
import ClippingSelectDuration from "@/components/media/clip/ClippingSelectDuration.vue";
import ClipForwardSelectDurarion from "@/components/media/clip/ClipForwardSelectDurarion.vue";

import mediaUtil from "@/components/media/utils/utils.js";
import clipUtil from "@/components/media/utils/clipUtil.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const Router = useRouter();
const route = useRoute();
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const appContext = getCurrentInstance()?.appContext;

const props = defineProps({
  config: {
    type: Object,
    default: {
      spacingSize: 3,
      wavebarWidth: 1,
      endClipTime: 0,
      barMaxheight: 30,
      minSelectDuration: 30,
      maxSelectDuration: Infinity,
      retentionPrefixDuration: 0,
      retentionSuffixDuration: 0,
      defaultSelectDuration: 0,
      defaultColor: "#fff",
      progressColor: "#72FFEC",
      selectAreaColor: "#fff",
    },
  },
  hideRemove: {
    type: Boolean,
    default: false,
  },
  url: {
    type: String,
    default: "",
  },
  duration: {
    type: Number,
    default: 0,
  },
  waveformData: {
    type: Object,
    default: [],
  },
  disabledTrim: {
    type: Boolean,
    default: true,
  },
  disabledReset: {
    type: Boolean,
    default: true,
  },
});

const emits = defineEmits([
  "syncSelectData",
  "syncSelectedData",
  "selectChangeLimit",
  "update:disabledTrim",
  "update:disabledReset",
]);

const refClippingSelectDuration = ref(null);

const formatTime = (time) => {
  return $$tValue("editor.extend_from_time", {
    time: mediaUtil.formatTimeMs(time),
  });
};

const stateData = {
  curPlayerData: null,
};

const renderData = reactive({
  startTime: "00:00",
  progress: 0,
  from: 0,
  to: 0,
  ifRenderClippingSelectDuration: true,
  waveformData: props.waveformData,
  from: 0,
  to: 0,
  duration: props.duration,
  lastTrimData: {
    from: 0,
    to: props.duration,
    duration: props.duration,
  },
});

const doSyncProgress = (progress, startTime) => {
  renderData.progress = progress;
  renderData.startTime = startTime;
};
const doSyncDuration = (duration) => {
  renderData.duration = duration;
};

const doSyncSelectData = (data) => {
  renderData.from = Math.round(data.from * 1000) / 1000;
  renderData.to = Math.round(data.to * 1000) / 1000;
  emits("syncSelectData", data);
};

const doSelectDataChange = (data) => {
  renderData.from = Math.round(data.from * 1000) / 1000;
  renderData.to = Math.round(data.to * 1000) / 1000;
  renderData.duration = data.duration;
  emits("syncSelectData", data);
};

const disabledTrim = computed(() => {
  console.log(
    renderData.from,
    renderData.to,
    renderData.lastTrimData.to - renderData.lastTrimData.from
  );
  return (
    renderData.from == 0 &&
    Math.round(renderData.to * 1000) ==
      Math.round(
        (renderData.lastTrimData.to - renderData.lastTrimData.from) * 1000
      )
  );
});

const disabledReset = computed(() => {
  return (
    renderData.lastTrimData.from == 0 &&
    renderData.lastTrimData.to == renderData.audioDuration
  );
});

const doSelectChangeLimit = (data) => {
  emits("selectChangeLimit", data);
};

const onRemoveClick = () => {
  emits("remove");
};

const performTrim = () => {
  const from =
    Math.round((renderData.lastTrimData.from + renderData.from) * 1000) / 1000;
  const to =
    Math.round((renderData.lastTrimData.from + renderData.to) * 1000) / 1000;
  renderData.waveformData = props.waveformData.slice(
    Math.floor((from / renderData.audioDuration) * props.waveformData?.length),
    Math.floor((to / renderData.audioDuration) * props.waveformData?.length)
  );
  renderData.lastTrimData = {
    from: from,
    to: to,
    duration: renderData.to - renderData.from,
  };
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.setClip(renderData.audioUrl, from, to);
  renderData.duration = renderData.to - renderData.from;
  // renderData.from = 0;
  // renderData.to = renderData.duration;
  renderData.ifRenderClippingSelectDuration = false;
  nextTick(() => {
    renderData.ifRenderClippingSelectDuration = true;
  });
};
const performReset = () => {
  renderData.waveformData = props.waveformData;
  renderData.duration = renderData.audioDuration;

  renderData.lastTrimData = {
    from: 0,
    to: renderData.audioDuration,
    duration: renderData.audioDuration,
  };
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.setClip(renderData.audioUrl, 0, renderData.audioDuration);
  renderData.duration = renderData.audioDuration;
  renderData.ifRenderClippingSelectDuration = false;
  nextTick(() => {
    renderData.ifRenderClippingSelectDuration = true;
  });
};

const doTogglePlay = async () => {
  if (renderData.isPlaying) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(stateData.curPlayerData?.url);
  } else {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.play(stateData.curPlayerData?.url, false);
  }
};
const doChangeProgress = (progress) => {
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.seek(stateData.curPlayerData?.url, progress);
  renderData.progress = progress;
};
const doSetPlayeData = async () => {
  const url = props.url;
  if (stateData.curPlayerData !== null) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releasePlayer(stateData.curPlayerData);
  }
  if (stateData.mounted) {
    stateData.curPlayerData = appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registerPlayUrl(url, {
      personalizedConfig: {
        loop: false,
        autoToStartIfNotCurrent: false,
        canSeekNotCurrent: true,
      },
      duration: renderData.duration ?? 0,
      clipStart: renderData.from,
      clipEnd: renderData.to,
      listeners: {
        onDurationChange({
          duration,
          durationTime,
          sourceDuration,
          sourceDurationTime,
        }) {
          // renderData.duration = duration;
        },
        onPlayStateChange(isPlaying) {
          renderData.isPlaying = isPlaying;
        },
        onLoadingStateChange(isLoading) {},
        onPositionChange: (obj) => {
          const { progress, currentTime, endTime } = obj;
          renderData.startTime = currentTime;
          renderData.endTime = endTime;
          if (
            !(
              renderData.touchSwipeState &&
              renderData.touchSwipeStateElType == "progress"
            )
          ) {
            renderData.progress = progress;
          }
        },
      },
    });
    // appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.seek(
    //   stateData.curPlayerData?.url,
    //   props.from / renderData.duration
    // );
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.play(stateData.curPlayerData?.url, false);
  }
};

const init = () => {
  renderData.audioUrl = props.url;
  renderData.audioDuration = props.duration;
  renderData.duration = props.duration;
  renderData.waveformData = props.waveformData;
  renderData.lastTrimData = {
    from: 0,
    to: props.duration,
    duration: props.duration,
  };
  doSetPlayeData();
};

watch(
  () => {
    return props.duration;
  },
  () => {
    renderData.duration = props.duration;
  }
);

watch(
  () => {
    return props.waveformData;
  },
  () => {
    renderData.waveformData = props.waveformData;
  }
);

watch(
  () => {
    return props.url;
  },
  () => {
    init();
  }
);

watch(
  () => {
    return disabledTrim.value;
  },
  () => {
    emits("update:disabledTrim", disabledTrim.value);
  }
);

watch(
  () => {
    return disabledReset.value;
  },
  () => {
    emits("update:disabledReset", disabledReset.value);
  }
);

watch(
  () => {
    return renderData.lastTrimData;
  },
  () => {
    emits("syncSelectedData", renderData.lastTrimData);
  }
);

onMounted(() => {
  stateData.mounted = true;
  init();
});

onUnmounted(() => {
  stateData.mounted = false;
  if (stateData.curPlayerData) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releasePlayer(stateData.curPlayerData, true);
  }
});

defineExpose({
  getSelectData: () => {
    return {
      from: renderData.from,
      to: renderData.to,
      selecDuration: renderData.to - renderData.from,
      duration: renderData.duration,
    };
  },
  setSelectData: (data) => {
    refClippingSelectDuration.value?.setRenerateSelectTime(data);
  },
  trimSelectData: (data) => {
    performTrim(data);
  },
  reset: () => {
    performReset();
  },
  getClipData: async () => {
    const decodeData = clipUtil.getDecodeDataByUrl(props.url);
    const clipDecodeData = await clipUtil.clipdDecodeData(
      decodeData,
      renderData.lastTrimData.from,
      renderData.lastTrimData.to
    );
    const exportData = await clipUtil.decodeDataToUrl(clipDecodeData);
    return exportData;
  },
});
</script>
<style lang="scss">
.edit-select-clip-audio {
  padding: 11px 0 8px;
  .clipping-select-duration-edit-op {
    border-right: 1px solid rgba(148, 173, 255, 0.2);
  }
  .clipping-select-duration-edit {
    .left-margin {
      margin-left: 0;
    }
    .clipping-select-duration-edit-margin {
      width: 12px;
    }
    .clipping-select-duration-edit-main-box {
      width: calc(100% - 48px - 40px - 12px * 2);
    }
  }
  .edit-select-clip-audio-select-area-box {
    display: flex;
    align-items: center;
    padding: 0 6px 0 14px;
  }
  .edit-select-clip-audio-select-area-time {
    font-size: 14px;
    font-weight: normal;
    line-height: 36px;
    color: #ffffff;
  }
  .clipping-forward-select-duration-edit {
    padding: 8px 0 0 0;
  }
  .clipping-select-duration-edit {
    padding: 8px 0 0 0;
  }
  .edit-select-clip-audio-select-close {
    padding: 0 6px 0 0;
  }
  &.edit-select-clip-audio--mobile {
    padding: 9px 0 12px 0;
    .clipping-select-duration-edit {
      .clipping-select-duration-edit-margin {
        width: 12px;
      }
      .clipping-select-duration-edit-main-box {
        width: calc(100% - 62px - 12px * 2 - 2px);
      }
    }
    .edit-select-clip-audio-select-area-edit-box {
      .clipping-select-duration-edit {
        padding: 8px 0 0 0;
      }
    }
    .edit-select-clip-audio-select-area-time {
      padding: 0 0 0 0;
    }
    .edit-select-clip-audio-select-close {
      padding: 0 6px 0 0;
    }
  }
}
</style>
